import { VHeaders } from '@/models/pagedlistmodel';

export function getOrphanAttachmentListHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('orphanList.orphanGrid.name') as string,
      align: 'left',
      value: 'attachmentName',
    },
    {
      text: 'CreatedAt',
      align: 'left',
      sortable: true,
      value: 'createdAt',
      fieldType: 'date',
    },
    {
      text: vm.$parent.$t('orphanList.orphanGrid.action') as string,
      isNotDataProp: true,
      align: 'center',
    },
  ];
}
